/**
 * Returns true if adding `candidate` as an ingredient of `editingRecipeId`
 * would create infinite recursion (direct self-reference or via descendantRecipes).
 *
 * Used by web and mobile recipe forms. Create flows pass a null/undefined
 * editingRecipeId and are not blocked.
 */
export const containsSelfOrDescendantRecipe = (editingRecipeId, candidate) => {
    if (!editingRecipeId) {
        return false;
    }
    if (candidate.__typename != null && candidate.__typename !== "Recipe") {
        return false;
    }
    if (candidate.id === editingRecipeId) {
        return true;
    }
    return candidate.descendantRecipes?.some(recipe => recipe.id === editingRecipeId) ?? false;
};
/**
 * Returns true if any ingredient in `ingredients` (or an optional standalone
 * `recipe` candidate) would create infinite recursion when added to
 * `editingRecipeId`.
 */
export const hasCircularRecipeIngredient = (editingRecipeId, ingredients, recipe) => ingredients.some(sa => containsSelfOrDescendantRecipe(editingRecipeId, sa.serving.foodOrRecipe)) ||
    (recipe != null && containsSelfOrDescendantRecipe(editingRecipeId, recipe));
//# sourceMappingURL=containsSelfOrDescendantRecipe.js.map